export function safeFileName(parts: Array<string | number | undefined>, extension: "webm" | "mp4"): string {
  const base = parts
    .filter((part): part is string | number => part !== undefined && part !== "")
    .map((part) => String(part).toLowerCase().replace(/[^a-z0-9-]+/g, "-").replace(/^-|-$/g, ""))
    .filter(Boolean)
    .join("-");
  return `${base || "index-motion"}.${extension}`;
}
